import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import './PopUp.scss';
import book from '../../Images/book.png'
import Image1Logo from '../../ImagesLogos/Image1Logo.png'
import closeMenu from '../../Images/closeMenu.png'
import Banner2Logo from '../../ImagesLogos/Banner2Logo.png'

export default function PopUp({ CitiePhone, CitiesData, setShowPopUp }) {
    const navigate = useNavigate()
    const location = useLocation()
    const url = new URL(window.location.href);

    return (
        <div className="PopUp">
            <div className="MainBanner">
                <div className="MainBannerHeader">
                    <img onClick={() => {
                        localStorage.setItem("showPopUp", true);
                        setShowPopUp(false)
                    }} fetchpriority="low" src={require(`../../Images/closeMenu.png`)} />
                </div>
                <div className="MainBannerLeft">
                    <div className="MainBannerLeftLogo">
                        <img fetchpriority="low" src={require(`../../ImagesLogos/Banner1Logo.png`)} />
                    </div>
                    <h1>Book Your Chimney Service Now!</h1>
                    <h3>Expert <span>{url.searchParams.get('kd') ? url.searchParams.get('kd').includes('near') ? url.searchParams.get('kd').replace('near me', '•') : url.searchParams.get('kd') + "," : ""}</span> chimney inspections, cleaning, and repairs in {CitiesData && CitiesData.Full ? CitiesData.Full.toUpperCase() : "Your Area"}</h3>
                    <h2>Protect your home and ensure peak performance today—don’t wait until problems arise!</h2>
                    <a href={`tel:${CitiePhone}`} onClick={() => {
                        localStorage.setItem("showPopUp", true);
                        setShowPopUp(false)
                    }}>Click To Call!</a>
                    <a onClick={() => {
                        localStorage.setItem("showPopUp", true);
                        navigate(`/book${location.search}`)
                        setShowPopUp(false)
                    }}>SCHEDULE ONLINE<img src={book} alt="Chimney Cleaning Near Me" /></a>
                </div>
            </div>
        </div>
    )
}
